import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Alert, Box} from 'views/components';
import {translate} from 'views/module';

import LoomCaregiverFeed, {LOOM_CAREGIVER_FEED_TABS} from './caregiver_feed/LoomCaregiverFeed';

import backend from 'utils/backend';

const initialFeedTab = () => {
  const requestedFeedTab = new URLSearchParams(window.location.search).get('feedTab');
  return LOOM_CAREGIVER_FEED_TABS.includes(requestedFeedTab) ? requestedFeedTab : 'PROFILE';
};

// A caregiver read only from Loom and keyed by its Loom caregiver id, like the Loom lead page.
const LoomCaregiverView = (props) => {
  const {caregiverId} = props;
  const progressWrap = props.statusProgressWrap;

  const [refresh, setRefresh] = React.useState(1);
  const [caregiver, setCaregiver] = React.useState(null);
  const [stage, setStage] = React.useState('LOADING');
  const [feedTab, setFeedTab] = React.useState(initialFeedTab);

  React.useEffect(() => {
    progressWrap(async () => {
      const output = await backend.loom.caregiver.getCaregiver(caregiverId);
      setCaregiver(output);
    }, {setStage, showProgress: !caregiver, debugString: 'LOOM_CAREGIVER_LOAD'});
  }, [caregiverId, refresh]);

  if (stage === 'ERROR' && !caregiver) {
    return (
      <Alert severity='error'>
        {translate('caregiver.LoomCaregiverDetail.LoadError')}
      </Alert>
    );
  }

  if (!caregiver) return null;

  return (
    <Box
      sx={{
        textAlign: 'left',
        width: {
          xs: '100%',
          md: '75%',
        },
      }}
    >
      <LoomCaregiverFeed
        caregiverId={caregiver.caregiverId}
        caregiver={caregiver}
        feedTab={feedTab}
        setFeedTab={setFeedTab}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </Box>
  );
};

LoomCaregiverView.propTypes = {
  caregiverId: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(LoomCaregiverView));
